module.exports = __webpack_public_path__ + "img/pointRank.d0cc1f29.png";